import React, { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { fetchAPI } from "../utils/fetchAPI";

interface AddSteelFormProps {
  show: boolean;
  onHide: () => void;
  onSuccess: () => void;
}

const AddSteelForm: React.FC<AddSteelFormProps> = ({ show, onHide, onSuccess }) => {
  const [formData, setFormData] = useState({
    name: "",
    steelType: 1, // Domyślnie "Cały arkusz"
    steelStatus: 0, // Domyślnie "Dostępna"
    width: "",
    height: "",
    thickness: "",
    weight: "",
    grade: "",
    usedTo: "", // Domyślnie pusty string
    info: "",
    quantity: 1,
  });
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      const quantity = Number(formData.quantity);
      if (quantity < 1 || quantity > 100) {
        throw new Error("Ilość arkuszy musi być między 1 a 100");
      }

      // Dodajemy tyle rekordów ile jest arkuszy
      for (let i = 0; i < quantity; i++) {
        const response = await fetchAPI("POST", "addSteel.php", {
          name: formData.name,
          steelType: formData.steelType,
          steelStatus: formData.steelStatus,
          width: Number(formData.width),
          height: Number(formData.height),
          thickness: Number(formData.thickness),
          weight: Number(formData.weight),
          grade: formData.grade,
          usedTo: formData.usedTo,
          info: formData.info,
        });

        if (!response.success) {
          throw new Error(response.message || "Błąd podczas dodawania stali");
        }
      }

      onSuccess();
      onHide();
    } catch (error: any) {
      setError(error.message || "Wystąpił błąd podczas dodawania stali");
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Dodaj nową pozycję stali</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Nazwa</Form.Label>
            <Form.Control type="text" name="name" value={formData.name} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Typ stali</Form.Label>
            <Form.Select name="steelType" value={formData.steelType} onChange={handleChange}>
              <option value={1}>Cały arkusz</option>
              <option value={2}>Odpad użyteczny</option>
              <option value={3}>Wykorzystana</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Status</Form.Label>
            <Form.Select name="steelStatus" value={formData.steelStatus} onChange={handleChange}>
              <option value={0}>Dostępna</option>
              <option value={1}>W użyciu</option>
              <option value={2}>Zarezerwowana</option>
              <option value={3}>Zniszczona</option>
              <option value={4}>Wykorzystana</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Szerokość (mm)</Form.Label>
            <Form.Control
              type="number"
              name="width"
              value={formData.width}
              onChange={handleChange}
              min="0"
              step="0.1"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Długość (mm)</Form.Label>
            <Form.Control
              type="number"
              name="height"
              value={formData.height}
              onChange={handleChange}
              min="0"
              step="0.1"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Grubość (mm)</Form.Label>
            <Form.Control
              type="number"
              name="thickness"
              value={formData.thickness}
              onChange={handleChange}
              min="0"
              step="0.1"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Waga (kg)</Form.Label>
            <Form.Control
              type="number"
              name="weight"
              value={formData.weight}
              onChange={handleChange}
              min="0"
              step="0.1"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Gatunek</Form.Label>
            <Form.Control type="text" name="grade" value={formData.grade} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Informacje</Form.Label>
            <Form.Control as="textarea" rows={3} name="info" value={formData.info} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Ilość arkuszy</Form.Label>
            <Form.Control
              type="number"
              name="quantity"
              value={formData.quantity}
              onChange={handleChange}
              min="1"
              max="100"
            />
          </Form.Group>
          {error && <div className="text-danger mb-3">{error}</div>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Anuluj
          </Button>
          <Button variant="primary" type="submit" disabled={isLoading}>
            {isLoading ? "Dodawanie..." : "Dodaj"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddSteelForm;
